import { render, staticRenderFns } from "./memory_match.config.vue?vue&type=template&id=d182a5c4"
import script from "./memory_match.config.vue?vue&type=script&lang=js"
export * from "./memory_match.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports